module.exports = __webpack_public_path__ + "/img/squirrelstreet-logo-header.ff4aa2652b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/squirrelstreet-logo-header.png
// module id = 1399
// module chunks = 0